export default __webpack_public_path__ + "static/media/ticket_purchase_pc.d75f00da.jpg";